import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

/**
 * The two-column card layout shared by /apps and /api-access: an even split on
 * wide screens, stacked on narrow ones, with one card treatment throughout.
 */

// Both columns stop growing once one is as wide as the widest content either
// page holds (720px) plus a card's 32px padding either side. Past that a
// column only grows its own empty space.
export const COLUMN_MAX_WIDTH = 784

// Spread into whichever Box is a column of the row.
export const columnSx = {
    flex: { lg: '1 1 0' },
    minWidth: 0,
    maxWidth: { lg: COLUMN_MAX_WIDTH },
}

export const cardSx = theme => ({
    p: { xs: 2.5, sm: 4 },
    borderRadius: '16px',
    border: `1px solid ${theme.palette.divider}`,
    bgcolor:
        theme.palette.mode === 'dark'
            ? 'rgba(255,255,255,0.02)'
            : 'rgba(0,0,0,0.012)',
})

export function PanelRow({ children, sx }) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                alignItems: { xs: 'stretch', lg: 'flex-start' },
                gap: { xs: 2, lg: 3 },
                ...sx,
            }}
        >
            {children}
        </Box>
    )
}

/** A card in a column, with an optional heading. */
export function Panel({ title, children, sx }) {
    const theme = useTheme()
    return (
        <Box sx={{ ...cardSx(theme), p: { xs: 2.5, sm: 3 }, ...sx }}>
            {title ? (
                <Typography variant="h6" sx={{ mb: 1.5 }}>
                    {title}
                </Typography>
            ) : null}
            {children}
        </Box>
    )
}
